const PHONE = '07760 881212';
const EMAIL = 'ryan.hopson@hotmail.co.uk';

export default function CTABanner() {
  return (
    <section
      className="relative py-20 font-body overflow-hidden bg-navy-800"
    >
      {/* Decorative gold border top */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gold-400"></div>

      {/* Decorative background circles */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute -top-12 -right-12 w-96 h-96 rounded-full bg-gold-400"></div>
        <div className="absolute -bottom-20 -left-12 w-80 h-80 rounded-full bg-gold-400"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className="w-16 h-16 flex items-center justify-center bg-gold-400/20 border border-gold-400/40 rounded-full mx-auto mb-6">
          <i className="ri-flashlight-fill text-gold-400 text-3xl"></i>
        </div>
        <h2 className="font-heading font-extrabold text-white mb-4" style={{ fontSize: 'clamp(2rem, 5vw, 3.5rem)', lineHeight: 1.1 }}>
          Need an Electrician in <span className="text-gold-400">Worksop?</span>
        </h2>
        <p className="text-gold-100/70 text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
          Fast, reliable, and honestly priced. Call us now or request a free quote — we&apos;ll get back to you the same day.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href={`tel:${PHONE.replace(/\s/g, '')}`}
            className="inline-flex items-center gap-3 bg-gold-400 hover:bg-gold-300 text-navy-800 font-bold text-lg px-9 py-4 rounded-md transition-all cursor-pointer whitespace-nowrap"
          >
            <span className="w-6 h-6 flex items-center justify-center">
              <i className="ri-phone-fill text-xl"></i>
            </span>
            Call {PHONE}
          </a>
          <a
            href={`mailto:${EMAIL}`}
            className="inline-flex items-center gap-3 border-2 border-gold-400 text-gold-400 hover:bg-gold-400 hover:text-navy-800 font-bold text-lg px-9 py-4 rounded-md transition-all cursor-pointer whitespace-nowrap"
          >
            <span className="w-6 h-6 flex items-center justify-center">
              <i className="ri-mail-send-fill text-xl"></i>
            </span>
            Send a Message
          </a>
        </div>
        <p className="text-gold-200/40 text-sm mt-6">
          No call-out charges for quotes · Fully insured · NAPIT Registered · Part P Registered
        </p>
      </div>

      {/* Decorative gold border bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gold-400"></div>
    </section>
  );
}
